<template>
  <v-card flat class="ma-0 pa-0">
    <v-card-text class="pa-0 pl-0">
      <SectionHeader :icon="icon" :label="label" :id="id"></SectionHeader>
    </v-card-text>
  </v-card>
</template>

<script>
import SectionHeader from "./SectionHeader";
export default {
  name: "CardedSectionHeader",
  components: {
    SectionHeader,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: () => {
        return (
          "carded_section_header_" +
          Math.random() +
          "_" +
          new Date().toTimeString()
        );
      },
    },
    icon: {
      type: String,
      default: "mdi-circle",
    },
  },
};
</script>